import "./OurCommitmentToEmployees.module.css";
import Header from "@/reusable_sections/Header";
import ReparationProfessionnelleVsBricolage from "./sections/ReparationProfessionnelleVsBricolage";
import WhyChooseUs from "./sections/WhyChooseUs";
import IntroHeadlineCatalog from "./sections/IntroHeadlineCatalog";
import EquestrianPropertyDoorChallenges from "./sections/EquestrianPropertyDoorChallenges";
import ValuePropsGrid from "./sections/ValuePropsGrid";
import CoreValues from "./sections/CoreValues";
import IntroHeadlineRepairService from "./sections/IntroHeadlineRepairService";
import WhyTrustAventuraGrid from "./sections/WhyTrustAventuraGrid";
import ReadyForAFreshLook from "./sections/ReadyForAFreshLook";
import Footer from "@/reusable_sections/Footer";
export default function OurCommitmentToEmployeesPage() {
  return <div>
      <Header />
      <ReparationProfessionnelleVsBricolage />
      <WhyChooseUs />
      <IntroHeadlineCatalog />
      <EquestrianPropertyDoorChallenges />
      <ValuePropsGrid />
      <CoreValues />
      <IntroHeadlineRepairService />
      <WhyTrustAventuraGrid />
      <ReadyForAFreshLook />
      <Footer />
    </div>;
}